import React, {useCallback, useEffect, useRef, useState} from "react";
import $ from "jquery";
import {IconButton} from "@material-ui/core";
import {arrowPositions, isInViewport} from "./utils";

function ArrowGuide(props) {

    let [pos, setPos] = useState("down");
    let defaultPaddingBottom = 30;
    let defaultStyles = {
        bottom: defaultPaddingBottom,
        top: undefined,
        left: 'calc(50% - 60px)'
    };
    let [styles, setStyles] = useState(defaultStyles);
    let [lastReference, setLastReference] = useState(null);
    let [lastPlaceholder, setLastPlaceholder] = useState(null);
    let [lastSpec, setLastSpec] = useState([{}, false]);
    let arrowEl = useRef(null);


    let jumpToLastReference = useCallback(() => {
        if (!lastReference) {
            return;
        }
        let el = $(lastReference);
        let next = el.offset().top - el.outerHeight();
        let tp = $('.top-toolbar').outerHeight();
        if (!tp || isNaN(tp)) {
            tp = 0;
        }
        let more = $(window).height() - (el.outerHeight() * 2) - tp;
        next = next - more;
        if (next < 0) {
            next = 0;
        }
        var diff = next - document.scrollingElement.scrollTop;
        if (diff < 0 || diff < 15) {
            if (lastPlaceholder) {
                lastPlaceholder.openSignInput();
            }
        }
        $([document.documentElement, document.body]).animate({
            scrollTop: next
        }, 1000, undefined, function () {
            $(window).trigger('scroll');
        });
    }, [lastReference, lastPlaceholder]);


    let reposition = useCallback((providePage, provideElement, lastStyles, lastAllSigned, force) => {

        let found = false;
        let where = "down";
        let last = null;
        let allSigned = true;


        for (let item of Object.keys(providePage)) {
            let el = providePage[item];
            if (!el) {
                continue;
            }
            let top = $(window).scrollTop();
            let at = $(el.element).offset().top;
            if (top + window.innerHeight > at) {
                el.setVisible(true);
            }
        }

        for (let item of Object.keys(provideElement)) {
            let el = provideElement[item];
            if (!el || !el.element || !props.signerID) {
                continue;
            }
            if (!el.placeholder._image && !el.placeholder.image) { // position self only on first un-signed placeholder
                let scrollTop = $(window).scrollTop();
                allSigned = false;
                let tel = el.element.parentNode;
                last = tel;
                let tEl = $(tel);
                let off = tEl.offset();
                let ports = isInViewport(tel);
                if (ports) {
                    setLastReference(tel);
                    setLastPlaceholder(el.placeholder);
                    found = true;
                    if (lastStyles.position === "fixed" || force) {
                        let arrowElCurr = $(arrowEl.current);
                        let nextStyles = {
                            ...styles,
                            bottom: undefined,
                            position: 'absolute',
                            top: off.top + ((tEl.height() / 2) - (arrowElCurr.outerHeight() / 2)),
                            left: off.left - (arrowElCurr.width() * 1.5)
                        };
                        lastStyles = nextStyles;
                        setStyles(nextStyles);
                        setPos("right");

                    }
                } else {
                    // where is the element up or down?
                    if (off.top < scrollTop) {
                        where = "up";
                    }
                }
                break;
            }
        }

        if (props.signerID && !found && (lastStyles.position !== "fixed" || allSigned !== lastAllSigned)) {
            setLastReference(last);
            let left = 'calc(50% - ' + (arrowEl && arrowEl.current ? ($(arrowEl.current).width() / 2) : '60') + 'px)';
            lastAllSigned = allSigned;
            if (allSigned) {
                where = "up";
                left = $('#finalizeButton').offset().left;
            }

            let next = {
                position: 'fixed',
                bottom: where === "down" ? defaultPaddingBottom : undefined,
                top: where === "up" ? 65 : undefined,
                left: left
            };
            setPos(where);
            lastStyles = next;
            setStyles(next);
        }
        return [lastStyles, lastAllSigned];
    }, []);

    useEffect(() => {
        let lastStyles = {...defaultStyles};
        let lastAllSigned = false;
        let scroll = () => {
            [lastStyles, lastAllSigned] = reposition(props.providePage, props.provideElement, lastStyles, lastAllSigned);
            setLastSpec([lastStyles, lastAllSigned]);
        };
        scroll();


        $(window).on("scroll", scroll);
        $(window).on("imageChanged", () => {
            setTimeout(scroll, 600);
        });

        return () => {
            $(window).off("scroll", scroll);
            $(window).off("imageChanged", scroll)
        };
    }, [props.provideElement, props.providePage]);

    useEffect(() => {
        let handle = setInterval(() => {
            //$(window).trigger('imageChanged');
        }, 1000);
        return () => clearInterval(handle);
    }, []);


    useEffect(() => {
        reposition(props.providePage, props.provideElement, lastSpec[0], lastSpec[1], true);
    }, [props.scale]);

    if (!props.signerID) {
        return null;
    }

    return <div ref={arrowEl} style={styles} className={"arrow-guide"}>
        <IconButton id={"arrowHead"} onClick={jumpToLastReference}><span
            style={{fontSize: 20}}>{arrowPositions[pos]}</span></IconButton>
    </div>
}


export default ArrowGuide;